import React from 'react';
import PropTypes from 'prop-types';
import { Alert, AlertTitle } from '@mui/material';

const MESSAGES = {
  patient:
    'Para criar termos e outros documentos, use a aba "Documentos" do paciente (Mais Opções → Documentos). Lá você edita o texto livremente, insere os dados do paciente com um clique, imprime e assina digitalmente.',
  configuration:
    'Em vez de enviar modelos em Word, crie os documentos direto no prontuário, na aba "Documentos" do paciente (Mais Opções → Documentos). Lá você edita o texto livremente, insere os dados do paciente com um clique, imprime e assina digitalmente.',
};

// Notice shown while "Termos" is being replaced by the "Documentos" tab.
export default function TermsDeprecationNotice({ context }) {
  return (
    <Alert severity="warning" variant="outlined" sx={{ mb: 2 }}>
      <AlertTitle sx={{ fontWeight: 'bold' }}>Os Termos serão descontinuados em breve</AlertTitle>
      {MESSAGES[context]}
    </Alert>
  );
}

TermsDeprecationNotice.propTypes = {
  context: PropTypes.oneOf(['patient', 'configuration']),
};

TermsDeprecationNotice.defaultProps = {
  context: 'patient',
};
